var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.756,
    height: 52.749,
    viewBox: "0 0 60.756 52.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#999;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-589.991 -939.231)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.991 939.231)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(4.832 22.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M334.559,716.107h6.663c7.506,0,10.125,3.492,10.125,9.893s-2.619,9.893-10.125,9.893h-6.663Zm6.285,15.8c4.48,0,5.383-1.891,5.383-5.906s-.9-5.906-5.383-5.906H339.5v11.813Z",
    transform: "translate(-334.559 -716.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M364.25,716.107v3.987h-5.442v15.8h-4.946v-15.8H348.45v-3.987Z",
    transform: "translate(-330.322 -716.107)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(45.946 27.625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M373.456,735.085c-4.8,0-7.391-3.375-7.391-7.448s2.59-7.449,7.391-7.449c4.887,0,7.419,3.375,7.419,7.449S378.343,735.085,373.456,735.085Zm0-3.229c2.066,0,3.4-1.4,3.4-4.219s-1.338-4.22-3.4-4.22c-2.008,0-3.376,1.4-3.376,4.22S371.447,731.856,373.456,731.856Z",
    transform: "translate(-366.064 -720.188)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(4.847 9.876)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M341.562,706.88l-3.076,8h-.84l-3.076-8v-.1h.823l2.656,7.076h.034l2.656-7.076h.823Z",
    transform: "translate(-334.57 -706.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M353.155,706.88l-2.909,8h-.84l-2.487-7.093h-.034l-2.487,7.093h-.84l-2.908-8v-.1h.807l2.5,6.975h.034l2.487-6.975h.84l2.487,6.975h.034l2.5-6.975h.808Z",
    transform: "translate(-332.716 -706.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M352.325,706.839l.083.723h.034a4.648,4.648,0,0,1,2.773-.975,2.577,2.577,0,0,1,2.354,1.075h.033a4.855,4.855,0,0,1,3.043-1.075c1.967,0,2.84,1.092,2.84,3.193v5.16h-.807v-5.025c0-1.749-.589-2.572-2.1-2.572a4.411,4.411,0,0,0-2.739,1.009,6.457,6.457,0,0,1,.151,1.429v5.16h-.808v-5.025c0-1.546-.269-2.572-2.033-2.572a4.17,4.17,0,0,0-2.656.992v6.606h-.806v-8.1Z",
    transform: "translate(-329.35 -706.587)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M370.547,751.768H334.941a4.089,4.089,0,0,1-4.085-4.085V703.1a4.089,4.089,0,0,1,4.085-4.085h35.607a4.089,4.089,0,0,1,4.086,4.085v44.58A4.089,4.089,0,0,1,370.547,751.768ZM334.941,700.5a2.607,2.607,0,0,0-2.6,2.6v44.58a2.607,2.607,0,0,0,2.6,2.6h35.607a2.607,2.607,0,0,0,2.6-2.6V703.1a2.607,2.607,0,0,0-2.6-2.6Z",
    transform: "translate(-330.856 -699.019)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDto);
export default __webpack_public_path__ + "static/media/logo_dto.4ccf37f4b5667e0fa4e7c14393722dd4.svg";
export { ForwardRef as ReactComponent };